// extracted by mini-css-extract-plugin
export default {"PaginationBox":"PaginationTable_PaginationBox__IL7dL","paginationMax":"PaginationTable_paginationMax__P5yWE","paginationMin":"PaginationTable_paginationMin__VKNIL"};